import styles from "./messages.module.scss"

const ToolPulse = () => (
  <div className={styles["row"]} data-testid="tool-pulse" aria-label="Running tool">
    <div className={styles["tool-pulse"]} aria-hidden="true" />
  </div>
)

export default ToolPulse
